// Currency formatting helper - defaults to Indian Rupees.
const SYMBOLS = { inr: "₹", usd: "$", eur: "€", gbp: "£" };

export function currencySymbol(code) {
  return SYMBOLS[(code || "inr").toLowerCase()] || "";
}

export function formatCurrency(amount, code = "inr", fractionDigits = 0) {
  const num = Number(amount ?? 0);
  const symbol = currencySymbol(code);
  const locale = (code || "inr").toLowerCase() === "inr" ? "en-IN" : "en-US";
  return `${symbol}${num.toLocaleString(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
}
